module.exports = __webpack_public_path__ + "img/sliders-simple.3caee69d.svg";